<template>
  <div class="section center" id="siglasSection">
    <div class="titulo l-700 text-center">
      ///
      <br />
      <br />
      <!-- Rodapé: -->
    </div>

    <br />
    <br />
    <div class="content l-700">
      <b> GLOSSÁRIO: </b>
      <br />
      <br />
      <b>[O] DEVIDO PROCESSO LEGAL</b>
      <p>
        O devido processo legal é uma garantia fundamental do Estado Democrático
        de Direito prevista pela Constituição de 1988 em seu art. 5ª inciso LIV
        no qual assegura a todos os cidadãos um processo que siga todas as
        etapas previstas pela legislação. Isso quer dizer que um indivíduo só
        pode ser privado de sua liberdade ou ter seus direitos restringidos após
        um processo que respeite todas as suas garantias de ampla defesa e
        contraditório.
      </p>
      <br />

      <b>SALVAGUARDAS CONSTITUCIONAIS</b>
      <p>
        Os critérios para avaliar a disponibilidade e a qualidade das
        informações públicas prestadas são aqueles contidos na Lei n. 12.527 que
        prevê que “É dever do Estado garantir o direito de acesso à informação,
        que será franqueada, mediante procedimentos objetivos e ágeis, de forma
        transparente, clara e em linguagem de fácil compreensão.” (Art. 5o).
        Cabendo aos órgãos do poder público assegurar: “(i) gestão transparente
        da informação, propiciando amplo acesso a ela e sua divulgação; e, (ii)
        proteção da informação, garantindo-se sua disponibilidade, autenticidade
        e integridade”
      </p>
      <br />
      <p>(Art. 6o, I e II).</p>
      <br />

      <p><b>CONSELHO NACIONAL DE JUSTIÇA</b></p>
      <p>
        É uma instituição pública que visa aperfeiçoar o trabalho do sistema
        judiciário brasileiro, principalmente no que diz respeito ao controle e
        à transparência administrativa e processual. É composto por
        desembargadores(as), juízes(as), e advogados(as). Atualmente é presidido
        por Luiz Fux, ministro do Supremo Tribunal Federal. Fonte:
        <a href="https://www.cnj.jus.br/composicao-atual/" target="_blank"
          >https://www.cnj.jus.br/composicao-atual/</a
        >
      </p>
      <br />
      <!-- <p><b>CONJUR IDEM</b> O QUE É</p>
      <p>
        É um site sobre Justiça e Direito, e é uma fonte de informação sobre o
        que acontece nos tribunais, escritórios e no dia a dia do país sob as
        lentes do Poder Judiciário. Fonte:
        <a href="https://www.conjur.com.br/a/quem_somos" target="_blank"
          >https://www.conjur.com.br/a/quem_somos</a
        >
      </p> -->
      <br />
      <p><b>PNI</b> - Programa Nacional de Imunização</p>
      <p>
        É um programa cujo objetivo é proporcionar a imunização da população
        brasileira a partir do nascimento, podendo se estender a vida toda. A
        imunização completa é composta por 19 imunizantes, abrange
        recém-nascidos(as), adultos(as), idosos(as), adolescentes, gestantes e
        toda a população indígena. Fonte:
        <a
          target="_blank"
          href="https://www.gov.br/saude/pt-br/acesso-a-informacao/acoes-e-programas/programa-nacional-de-imunizacoes-vacinacao"
          >https://www.gov.br/saude/pt-br/acesso-a-informacao/acoes-e-programas/programa-nacional-de-imunizacoes-vacinacao</a
        >
      </p>
      <!-- <p>DEPEN: Departamento Penitenciário Nacional</p>
      <br />
      <br />
      <b>RESOLUÇÕES </b>
      <p>
        Recomendação 62/2020 do Conselho Nacional de Justiça ao dispor sobre a
        necessidade de reavaliação das prisões preventivas não implica na
        revogação automática das custódias em razão da pandemia.
      </p> -->
      <p>
        Recomendação de que cada caso seja individualmente analisado pelos
        magistrados - pegar a recomendação e trabalhar com casos individuais.
      </p>
      <br />
      <br />
      <b>LISTA DE SIGLAS </b>
      <br />
      <br />
      <p><b>ACP</b> – Ação Civil Pública</p>
      <p>
        A Ação Civil Pública é o mecanismo utilizado para proteção de bens e
        direitos coletivos a partir da produção de dano público, seja ele
        causado pelo Estado ou por particular. Conforme a Lei 7.347/85 podem
        ingressar com ACP: o Ministério Público, a Defensoria Pública, a União,
        os Estados, o Distrito Federal e os Municípios, Autarquias, empresas
        públicas, fundações ou sociedades de economia mista e as associações.
      </p>
      <br />
      <p><b>ADPF</b> – Arguição de Descumprimento de Preceito Fundamental</p>
      <p>
        As ADPFs são ações propostas diretamente ao Supremo Tribunal Federal
        para evitar ou reparar lesão praticada pelo Poder Público contra
        preceitos fundamentais (previstos na Constituição Federal).
      </p>
      <br />
      <p><b>CNJ</b> – Conselho Nacional de Justiça</p>
      <p>
        É uma instituição pública que visa aperfeiçoar o trabalho do sistema
        judiciário brasileiro, principalmente no que diz respeito ao controle e
        à transparência administrativa e processual. É composto por
        desembargadores(as), juízes(as), e advogados(as). Atualmente é presidido
        por Luiz Fux, ministro do Supremo Tribunal Federal. Fonte:
        <a target="_blank" href="https://www.cnj.jus.br/composicao-atual/"
          >https://www.cnj.jus.br/composicao-atual/</a
        >
      </p>
      <br />
      <p>
        <b>CNPCP</b> - Conselho Nacional de Política Criminal e Penitenciária
      </p>
      <p>
        O CNPCP é o primeiro dos órgãos da execução penal, sendo integrado por
        profissionais da área jurídica, professores e representantes da
        sociedade civil. Ele tem sede na capital do país e é subordinado ao
        Ministro da Justiça. Sua principal atribuição é a produção de subsídios
        destinados à implementação de uma nova política criminal e penitenciária
        a partir de periódicas avaliações do sistema criminal e penitenciário
      </p>
      <br />
      <p><b>DEPEN</b> – Departamento Penitenciário Nacional</p>
      <p>
        O DEPEN é o órgão responsável pelo acompanhamento e aplicação da Lei de
        Execução Penal no Brasil a partir da Política Penitenciária Nacional.
        Além disso, também é responsável por gerir o Fundo Penitenciário
        Nacional (FUNPEN).
      </p>
      <br />
      <p><b>DPE</b> – Defensoria Pública Estadual</p>
      <p>
        A Defensoria Pública é o órgão responsável pela defesa, orientação e
        assistência dos cidadãos que possuem insuficiência de recursos para
        arcar com custas processuais. Além disso, é uma instituição que promove
        a defesa dos direitos humanos, sejam eles individuais ou coletivos. As
        Defensorias existem com atuação em âmbito federal, pela Defensoria
        Pública da União (DPU) e pelas Defensorias Estaduais, presentes em todos
        os estados brasileiros.
      </p>
      <br />
      <p><b>DPESP</b> – Defensoria Pública do Estado de São Paulo</p>
      <br />
      <p><b>FUNPEN</b> – Fundo Penitenciário Nacional</p>
      <p>
        O Fundo Penitenciário Nacional integra o orçamento fiscal da União e
        possui o objetivo de financiar e apoiar atividades e programas
        vinculados ao sistema penitenciário nacional.
      </p>
      <br />
      <p><b>IDDD</b> – Instituto de Defesa do Direito de Defesa</p>
      <p>
        O IDDD é uma organização formada por advogados/as criminalistas e
        defensores/as dos direitos humanos que trabalham pela garantia do
        direito de defesa e devido processo legal frente ao poder punitivo do
        Estado.
      </p>
      <br />
      <p>
        <b>INFOPEN</b> - Levantamento Nacional de Informações Penitenciárias
      </p>
      <p>
        O Infopen, criado em 2004, é um relatório que apresenta as estatísticas
        e números do sistema penitenciário brasileiro. Os dados são atualizados
        pelos gestores de estabelecimentos prisionais do país.
      </p>
      <br />
      <p><b>LAI</b> – Lei de Acesso à Informação</p>
      <p>
        A LAI é uma lei que busca garantir a todos os cidadãos e cidadãs o
        direito constitucional de acesso às informações produzidas e armazenadas
        pelo Estado nos três Poderes da União, Estados, Distrito Federal e
        Municípios.
      </p>
      <br />
      <p><b>MP</b> – Ministério Público</p>
      <p>
        O Ministério Público é uma instituição pública autônoma que tem a
        obrigação de defender a ordem jurídica, o regime democrático e os
        interesses sociais e individuais indisponíveis. A instituição tem
        autonomia para organizar as suas funções administrativas e independência
        para gerir e executar o seu orçamento.
      </p>
      <br />
      <p><b>PEI</b> – Plano Estadual de Imunização</p>
      <br />
      <p><b>SAP</b> – Secretaria da Administração Penitenciária</p>
      <p>
        A Secretaria de Administração Penitenciária é órgão presente em todos os
        estados que promove a execução das penas privativas de liberdade e
        medidas de segurança alternativas à prisão.
      </p>
      <br />
      <p>
        <b>SISDEPEN</b> – Sistema de Informações do Departamento Penitenciário
        Nacional
      </p>
      <p>
        O SISDEPEN é a plataforma virtual de estatísticas utilizada pelo sistema
        penitenciário brasileiro para sintetizar as informações sobre os
        estabelecimentos penais e a população carcerária. Os dados devem ser
        atualizados pelas secretarias de segurança e justiça estaduais,
        administrações penitenciárias dos estados e Judiciário.
      </p>
      <br />
      <p><b>STF</b> – Supremo Tribunal Federal</p>
      <p>
        O STF é o órgão máximo do Poder Judiciário brasileiro, formado por 11
        ministros nomeados pelo Presidente da República. O STF é um Tribunal com
        jurisdição em todo o território nacional e nele são julgadas ações que
        sejam relevantes para todo o país. Entre suas funções principais, estão
        definir se uma lei ou ato normativo federal ou estadual é constitucional
        e julgar o presidente, o vice-presidente, os membros do Congresso
        Nacional e o procurador-geral da República, além de seus próprios
        membros.
      </p>
      <br />
      <p><b>STJ</b> – Superior Tribunal de Justiça</p>
      <p>
        O STJ é o Tribunal responsável por uniformizar a interpretação da lei
        federal em todo o Brasil. Sua atribuição é solucionar definitivamente
        casos civis e criminais que não envolvam matéria constitucional nem a
        justiça especializada.
      </p>
      <br />
      <p><b>UFPE</b> – Universidade Federal de Pernambuco</p>
      <br />
      <p><b>UnB</b> – Universidade de Brasília</p>
      <br />
      <p><b>UNICAP</b> – Universidade Católica de Pernambuco</p>
      <br />
      <p><b>UFSC</b> – Universidade Federal de Santa Catarina</p>
      <br />
      <p><b>UEFS</b> – Universidade Estadual de Feira de Santana</p>
      <br />
      <!-- <p><b>DPE</b> – Defensoria Pública Estadual</p>
      <p>
        A Defensoria Pública é o órgão responsável pela defesa, orientação e
        assistência dos cidadãos que possuem insuficiência de recursos para
        arcar com custas processuais. Além disso, é uma instituição que promove
        a defesa dos direitos humanos, sejam eles individuais ou coletivos. As
        Defensorias existem com atuação em âmbito federal, pela Defensoria
        Pública da União (DPU) e pelas Defensorias Estaduais, presentes em todos
        os estados brasileiros.
      </p>
      <br /> -->
      <div class="alterado">
        <i>*Os nomes das vítimas foram alterados.</i>
      </div>
      <br />
      <br />
      <br />
      <br />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.section {
  min-height: 100vh;
}

p {
  margin-top: 0;
  margin-bottom: 0.2rem;
}
</style>